export default __webpack_public_path__ + "static/media/linkedin.5ad83af5.svg";